import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-access-denied',
  styles: [`
    .icon-align {
      font-size: 50px; 
      display: inline-flex;
      vertical-align: top;
    }
  `], 
  template: `
    <div fxLayout="row wrap" fxLayoutAlign="center center" class="mt-20">
        <div fxFlex="100" fxLayoutAlign="center">
            <h1 style="margin-bottom: 5px; font-size: 50px;">
                <mat-icon color="warn" class="icon-align" [inline]="true">report_problem</mat-icon>Access Denied
            </h1>
        </div>    
    </div>
    <div fxLayout="row wrap" fxLayoutAlign="center" class="mt-20">
        <div fxFlex="100" fxLayoutAlign="center">
            <h3>You are not authorized to access this page</h3>
        </div>    
    </div>
  `
})
export class AccessDeniedComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
